import cleanSlateLogo from "@/assets/clean-slate-logo.webp";
import brunoSouza from "@/assets/bruno-souza.webp";
import {
  Attribution,
  CountUp,
  QuoteCard,
  useInViewRef,
} from "@/components/sections/testimonial/shared";

export function Step2Testimonial() {
  const { ref, inView } = useInViewRef<HTMLElement>();

  return (
    <section ref={ref} className="flex flex-col">
      <div className="flex items-center gap-6">
        <h2 className="text-4xl font-bold tracking-tight text-foreground">
          We increased this
          <br />
          website&rsquo;s bookings
        </h2>
        <span className="text-gradient-cycle text-6xl font-bold sm:text-7xl lg:text-8xl tabular-nums">
          <CountUp target={10} start={inView} suffix="x" />
        </span>
      </div>

      <QuoteCard>
        Since launching our new website, we get steady quote requests every
        week and our schedule stays{" "}
        <span className="text-gradient-cycle font-bold">booked out.</span>{" "}
        It&rsquo;s been a game-changer for our junk removal business.
      </QuoteCard>

      <Attribution
        avatarSrc={brunoSouza}
        avatarAlt="Bruno Souza"
        name="Bruno Souza"
        role="Owner, Clean Slate Junk Removal"
        logoSrc={cleanSlateLogo}
        logoAlt="Clean Slate Junk Removal logo"
      />
    </section>
  );
}
